import React from 'react';

interface FeatureToggleTitleProps {
  text: string;
}

export default function FeatureToggleTitle({ text }: FeatureToggleTitleProps) {
  return <p className='mb-1 text-base font-semibold text-title'>{text}</p>;
}
